import { useState } from 'react';
import TrainingHero from './components/TrainingHero';
import SkillLevels from './components/SkillLevels';
import CoachingPrograms from './components/CoachingPrograms';
import TrainingStats from './components/TrainingStats';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import RegistrationModal from '../../components/feature/RegistrationModal';
import CoachFinderModal from '../../components/feature/CoachFinderModal';

export default function TrainingPage() {
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);
  const [isCoachFinderOpen, setIsCoachFinderOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-950">
      <Header onJoinClick={() => setIsRegistrationOpen(true)} />
      <TrainingHero onFindCoachClick={() => setIsCoachFinderOpen(true)} />
      <SkillLevels />
      <CoachingPrograms />
      <TrainingStats />
      <Footer />
      <RegistrationModal 
        isOpen={isRegistrationOpen} 
        onClose={() => setIsRegistrationOpen(false)} 
      />
      <CoachFinderModal 
        isOpen={isCoachFinderOpen} 
        onClose={() => setIsCoachFinderOpen(false)} 
      />
    </div>
  );
}